/* dhaara-float-search.js - Floating Search & WhatsApp Widget Script */

(function () {
  'use strict';

  function initFloatSearch(container) {
    if (!container || container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    const sectionId = container.dataset.sectionId;
    const fab       = container.querySelector('.dhaara-search-fab');
    
    // Find overlay and drawer, supporting either within section container or globally scoped
    const overlay   = document.querySelector(`.dhaara-search-overlay[data-section-id="${sectionId}"]`) || container.querySelector('.dhaara-search-overlay');
    const drawer    = document.querySelector(`.dhaara-search-drawer[data-section-id="${sectionId}"]`) || container.querySelector('.dhaara-search-drawer');

    if (!fab || !overlay || !drawer) return;

    const input     = drawer.querySelector('.dhaara-search-input');
    const clearBtn  = drawer.querySelector('.dfs-clear-btn');
    const idleState = drawer.querySelector('.dfs-idle-state');
    const loading   = drawer.querySelector('.dfs-loading');
    const grid      = drawer.querySelector('.dfs-grid');
    const countEl   = drawer.querySelector('.dfs-count');

    let isOpen = false;
    let debounceTimer = null;
    let activeController = null;

    function openDrawer() {
      isOpen = true;
      overlay.classList.add('open');
      drawer.classList.add('open');
      fab.setAttribute('aria-expanded', 'true');
      setTimeout(() => { if (input) input.focus(); }, 380);
      document.addEventListener('keydown', onEsc);
    }

    function closeDrawer() {
      isOpen = false;
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      fab.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onEsc);
      fab.focus();
    }

    function onEsc(e) {
      if (e.key === 'Escape') closeDrawer();
    }

    const handleFabClick = () => { isOpen ? closeDrawer() : openDrawer(); };
    const handleOverlayClick = () => { closeDrawer(); };

    fab.addEventListener('click', handleFabClick);
    overlay.addEventListener('click', handleOverlayClick);

    if (clearBtn && input) {
      clearBtn.addEventListener('click', () => {
        input.value = '';
        clearBtn.classList.remove('visible');
        resetToIdle();
        input.focus();
      });
    }

    if (input) {
      input.addEventListener('input', function () {
        const q = this.value.trim();
        if (clearBtn) clearBtn.classList.toggle('visible', q.length > 0);
        clearTimeout(debounceTimer);
        if (q.length < 2) { resetToIdle(); return; }
        debounceTimer = setTimeout(() => fetchResults(q), 320);
      });
    }

    function resetToIdle() {
      if (activeController) { activeController.abort(); activeController = null; }
      if (idleState) idleState.style.display = '';
      if (loading) loading.style.display   = 'none';
      if (grid) {
        grid.style.display      = 'none';
        grid.innerHTML          = '';
      }
      if (countEl) countEl.style.display   = 'none';
    }

    function fetchResults(query) {
      if (activeController) activeController.abort();
      activeController = new AbortController();
      if (idleState) idleState.style.display = 'none';
      if (loading) loading.style.display   = 'flex';
      if (grid) grid.style.display      = 'none';
      if (countEl) countEl.style.display   = 'none';

      const url = '/search/suggest.json?q=' + encodeURIComponent(query)
                + '&resources[type]=product&resources[limit]=12'
                + '&resources[options][fields]=title,product_type,variants.title,tag';

      fetch(url, { signal: activeController.signal })
        .then(r => r.json())
        .then(data => {
          if (loading) loading.style.display = 'none';
          const products = (data.resources?.results?.products) || [];
          renderResults(products, query);
        })
        .catch(err => {
          if (err.name === 'AbortError') return;
          if (loading) loading.style.display = 'none';
          renderResults([], query);
        });
    }

    function renderResults(products, query) {
      if (!grid) return;
      grid.innerHTML = '';
      if (products.length === 0) {
        grid.innerHTML = '<li class="dfs__no-results">No products found for &ldquo;' + escHtml(query) + '&rdquo;</li>';
        grid.style.display = 'grid';
        if (countEl) countEl.style.display = 'none';
        return;
      }
      if (countEl) {
        countEl.textContent = products.length + ' result' + (products.length !== 1 ? 's' : '') + ' for "' + query + '"';
        countEl.style.display = 'block';
      }
      products.forEach(p => {
        const li = document.createElement('li');
        li.setAttribute('role', 'listitem');
        li.innerHTML = buildCard(p);
        grid.appendChild(li);
      });
      grid.style.display = 'grid';
    }

    function buildCard(p) {
      const title = escHtml(p.title || '');
      const url   = p.url || '#';

      let rawPrice = parseFloat(p.price || 0);
      const priceStrValue = String(p.price || '');
      if (priceStrValue && !priceStrValue.includes('.')) {
        // cents
      } else if (priceStrValue) {
        rawPrice = rawPrice * 100;
      }

      let rawCompare = parseFloat(p.compare_at_price_max || p.compare_at_price || 0);
      const compareStrValue = String(p.compare_at_price_max || p.compare_at_price || '');
      if (compareStrValue && !compareStrValue.includes('.')) {
        // cents
      } else if (compareStrValue) {
        rawCompare = rawCompare * 100;
      }

      const hasDiscount = rawCompare > rawPrice && rawCompare > 0;

      const priceStr   = formatMoney(rawPrice);
      const compareStr = hasDiscount ? formatMoney(rawCompare) : '';
      const pct        = hasDiscount ? Math.round((rawCompare - rawPrice) / rawCompare * 100) : 0;

      const imgSrc = p.featured_image?.url || '';

      const savedBadge = hasDiscount
        ? `<div class="dfs__saved-badge">Save ${pct}%</div>` : '';

      const imgHtml = imgSrc
        ? `<img class="dfs__card-img" src="${escHtml(imgSrc)}" alt="${title}" loading="lazy" width="300" height="160">`
        : `<div class="dfs__card-media-placeholder">No image</div>`;

      const compareHtml = hasDiscount
        ? `<span class="dfs__price-compare">${escHtml(compareStr)}</span>
           <span class="dfs__price-discount">${pct}% off</span>` : '';

      const stars = Array(5).fill(
        `<svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
         </svg>`
      ).join('');

      return `
        <a class="dfs__card" href="${escHtml(url)}" aria-label="View ${title}">
          <div class="dfs__card-media">
            ${imgHtml}
            <div class="dfs__card-overlay" aria-hidden="true"></div>
            ${savedBadge}
          </div>
          <div class="dfs__card-body">
            <div class="dfs__stars" aria-label="5 stars">${stars}</div>
            <div class="dfs__name">${title}</div>
            <div class="dfs__price-row">
              <span class="dfs__price">${escHtml(priceStr)}</span>
              ${compareHtml}
            </div>
            <div class="dfs__btn">View Product</div>
          </div>
        </a>`;
    }

    function formatMoney(amountInCents) {
      const format = window.dhaaraMoneyFormat || '₹{{amount}}';
      const amount = amountInCents / 100;
      
      return format.replace(/{{\s*(\w+)\s*}}/g, function(_, placeholder) {
        const rounded = Math.round(amount);
        switch (placeholder) {
          case 'amount':
            return amount % 1 === 0 ? String(rounded) : amount.toFixed(2);
          case 'amount_no_decimals':
            return String(rounded);
          case 'amount_with_comma_separator':
            return amount % 1 === 0 ? rounded.toLocaleString('en-IN') : amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          case 'amount_no_decimals_with_comma_separator':
            return rounded.toLocaleString('en-IN');
          default:
            return String(rounded);
        }
      });
    }

    function escHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    const cleanup = () => {
      fab.removeEventListener('click', handleFabClick);
      overlay.removeEventListener('click', handleOverlayClick);
      document.removeEventListener('keydown', onEsc);
      if (activeController) activeController.abort();
    };

    container.addEventListener('floatsearch:destroy', cleanup, { once: true });
  }

  function initAllFloatSearches() {
    const containers = document.querySelectorAll('.dhaara-fab-stack-wrap');
    containers.forEach(container => {
      initFloatSearch(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFloatSearches);
  } else {
    initAllFloatSearches();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const container = document.querySelector(`.dhaara-fab-stack-wrap[data-section-id="${e.detail.sectionId}"]`);
    if (container) {
      initFloatSearch(container);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const container = document.querySelector(`.dhaara-fab-stack-wrap[data-section-id="${e.detail.sectionId}"]`);
    if (container) {
      container.dispatchEvent(new CustomEvent('floatsearch:destroy'));
    }
  });

})();
